// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__2jU8z"};